import Button from "antd/lib/button";
import Modal from "antd/lib/modal/Modal";
import { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import Tabs from "antd/lib/tabs";
import { SettingOutlined } from "@ant-design/icons";
import UserComponent from "./components/User/User.component";
import CredentialComponent from "./components/Credential/Credential.component";
import { useForm } from "antd/lib/form/Form";

const SettingsComponent: FC<any> = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [basic_info] = useForm();

  const handleOk = () => {
    basic_info.submit();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        style={{ paddingLeft: "0px", marginTop: "5px" }}
        className="d-block"
        icon={<SettingOutlined />}
        type="link"
        size="middle"
        onClick={() => setIsModalVisible(true)}
      >
        Settings
      </Button>
      <Modal
        style={{ top: 10 }}
        width={800}
        title="Settings"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <>
            <Button
              key="submit"
              type="primary"
              htmlType="submit"
              loading={loading}
              onClick={handleOk}
            >
              Save Changes
            </Button>
          </>,
        ]}
      >
        <Tabs tabPosition="left">
          <Tabs.TabPane tab="Basic Info" key={'1'}>
            <UserComponent
              form={basic_info}
              loading={loading}
              setIsModalVisible={setIsModalVisible}
              setLoading={setLoading}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Credential" key={'2'}>
            <CredentialComponent />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
};
/**
 * Map State to Props
 *
 * @param state
 */
const mapStateToProps = (state: any) => ({
  log: state.log.fetchAll,
});

/**
 * Map Dispatch to Props
 *
 * @param dispatch
 */
// const mapDispatchToProps = (dispatch: any) => ({
//   fetchLog: (action: any) => dispatch(fetchAllLog(action)),
// });

export default connect(mapStateToProps)(SettingsComponent);
